import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CreateFolderComponent } from '@common-standalone/file-operations/create-folder/create-folder.component';
import { EnhancedShareLinkComponent } from '@common-standalone/file-operations/enhanced-share-link/enhanced-share-link.component';
import { FileInfoComponent } from '@common-standalone/file-operations/file-info/file-info.component';
import { ShareDiscardComponent } from '@common-standalone/file-operations/share-discard/share-discard.component';
import { ShareLinkComponent } from '@common-standalone/file-operations/share-link/share-link.component';
import { ManageVersionComponent } from '@common-standalone/file-operations/versioning/manage-version/manage-version.component';
import { DeleteItemsComponent } from '@mainrepo/app/shared-standalone-components/file-operations/delete-items/delete-items.component';
import { MoveCopyComponent } from '@mainrepo/app/shared-standalone-components/file-operations/move-copy/move-copy.component';
import { PrivateShareComponent } from '@mainrepo/app/shared-standalone-components/file-operations/private-share/private-share.component';
import { RenameComponent } from '@mainrepo/app/shared-standalone-components/file-operations/rename/rename.component';



@NgModule({
  imports: [
    CommonModule,
    EnhancedShareLinkComponent,
    PrivateShareComponent,
    DeleteItemsComponent,
    RenameComponent,
    FileInfoComponent,
    // PreviewModule,
    MoveCopyComponent,
    ManageVersionComponent,
    ShareDiscardComponent,
    ShareLinkComponent,
    CreateFolderComponent
  ],
  exports:[
    EnhancedShareLinkComponent,
    PrivateShareComponent,
    DeleteItemsComponent,
    RenameComponent,
    FileInfoComponent,
    // PreviewModule,
    MoveCopyComponent,
    ManageVersionComponent,
    ShareDiscardComponent,
    ShareLinkComponent,
    CreateFolderComponent
  ]
})
export class EnhancedShareFileOperationsModule { }
